import {Input} from "@/uikit";
import {Icon} from "@/elements-react/fix-icon";
import {testid} from "@fixparts/testid/index.ts";
import {useTranslation} from "react-i18next";
import {Button} from "@headlessui/react";
import styles from "./banner-search.module.scss";
import {useSearchCommon} from "@/elements-react/fix-search/search.common.ts";
import {PageTags} from "@/elements-react/document-elements/page-tags.tsx";
import classNames from "classnames";
import React from "preact/compat";
import {FixButton} from "@/elements-react/fix-button";

export const BannerSearch: React.FC<{size?: 'sm' | 'lg'}> = ({ size = 'lg' }) => {
    const { t } = useTranslation();
    const { searchValue, handleChange, handleKeyDown, handleBlur, search, jsonLdDataset } = useSearchCommon();

    const suffix = (
        <div className={styles['search-controls']}>
            <Button className={styles['search-button']}>
                <Icon width={20} name="search" {...testid({ elm: "searchBtn" })} /> Find
            </Button>
        </div>
    )

    return (
        <div className={classNames(styles['search'], styles[size])}>
            <Input
                className={styles['search-input']}
                name="mpn-search"
                value={searchValue}
                onChange={handleChange}
                onBlur={handleBlur}
                onKeyDown={handleKeyDown}
                placeholder={t("kmaqihq7zxarr34z.search-placeholder", "Search for part number")}
                inputSize={'large'}
                {...testid({ elm: "searchInput" })}
                suffix={suffix}
                inputClassNames={styles['search-input-field']}
                suffixClassNames={classNames(styles['suffix'], styles['search-button-suffix'])}
            />
            <PageTags jsonld={jsonLdDataset} />
        </div>
    )
}